import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll";
import { FocusTrap } from "./focustrap.js";
export const Dialog = ({ isOpen, onClose, children }) => {
    const [isScrollLocked, setScrollLocked] = useState(false);
    const handleBackgroundClick = useCallback(() => {
        onClose();
    }, [onClose]);
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape" && isOpen) {
                onClose();
            }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [isOpen, onClose]);
    useEffect(() => {
        // Has to run in the browser
        setScrollLocked(getComputedStyle(document.body).overflow !== "hidden");
    }, []);
    return isOpen
        ? createPortal(_jsx(RemoveScroll, { enabled: isScrollLocked, children: _jsx("div", { "aria-modal": true, role: "dialog", className: "fixed inset-0 bg-black/80 flex items-end md:items-center justify-center z-[100000] animate-fade-in", onClick: handleBackgroundClick, children: _jsx(FocusTrap, { children: _jsx("div", { className: "animate-fade-in animate-slide-up max-md:w-screen md:max-w-sm", onClick: (event) => event.stopPropagation(), children: children }) }) }) }), document.body)
        : null;
};
//# sourceMappingURL=dialog.js.map